import React, {useContext, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useParams} from 'react-router-dom';
import {UserProfileContext} from '../../../components/UserProfileContext.js';
import {OPTIONAL_FIELDS} from '../../../utils/applicationConst';
import isValidDateOfBirth, {isDateOfBirthWithinAcceptableRange} from '../../../utils/date';
import {isValidNIN} from '../../../utils/string';
import Form from '../Form';
import formDefinition from './utils/formDefinition';
import getForms from './utils/forms';

const PromotionForm = () => {
  const {userProfile} = useContext(UserProfileContext);
  const {slug} = useParams();
  const {t} = useTranslation();

  const [form, setForm] = useState({
    activeStep: 0,
    ...(formDefinition(userProfile)),
  });
  const activeStep = form.activeStep;

  const isNotOptionalField = (field) => !OPTIONAL_FIELDS.includes(field);

  const isFieldValueEmpty = (fieldValue) => !fieldValue || 0 === fieldValue.length;

  const isValid = (step) => {
    const fieldError = {};
    const errorFields = Object.keys(form[step].data).filter(isNotOptionalField).filter(
      field => {
        if (field === 'firstLanguage') return form[slug].data['firstLanguageEnglish'] === 'no' && isFieldValueEmpty(form[slug].data[field]);
        if (field === 'gender') return form[slug].data['genderMatch'] === 'no' && 0 === form[slug].data[field].length;
        if (field === 'dateOfBirth') {
          if (!isValidDateOfBirth(form[slug].data.dateOfBirth)) return true;
          if(!isDateOfBirthWithinAcceptableRange(form[slug].data.dateOfBirth, 16, 80)) {
            fieldError.dateOfBirth = t('common.dateOfBirthAgeError');
            return true;
          }
          return false;
        }
        if (field === 'disabilityCategory') {
          return form[slug].data['disability'] === 'yes' && isFieldValueEmpty(form[slug].data[field]);
        }
        if (field === 'otherNationalities') {
          return form[slug].data['nationalities']?.includes('other') && !form[slug].data['otherNationalities']?.filter(Boolean)?.length;
        }
        if (field === 'nationalInsuranceNumber') {
          return !isValidNIN(form[slug].data[field]);
        } else {
          return isFieldValueEmpty(form[step].data[field]);
        }
      }
    );
    setForm({
      ...form,
      [step]: {...form[step], errors: [...errorFields], fieldError},
    });

    return errorFields.length === 0;
  };

  return (
    <Form title="Apply for an exam"
      isValid={isValid}
      getForms={getForms}
      activeStep={activeStep}
      type="promotion"
      slug={slug}
      form={form}
      setForm={setForm}
      formDefinition={formDefinition} />
  );
};
export default PromotionForm;
